/**
 * Legal copy for Privisy Terms of Service and scan disclaimer.
 * Source: Grace's draft — Issue #152
 */



export const SCAN_DISCLAIMER_SUMMARY =
  'Automated technical audit, not legal advice.';

export const SCAN_DISCLAIMER = `This report is generated by automated software and is provided for informational purposes only. It is not legal advice and does not constitute a compliance certification or audit opinion.

Privisy analyzes publicly observable technical signals: cookie behavior, network requests, tracker presence, and privacy policy text. It cannot assess your internal data handling practices, vendor contracts, employee training, or other non-public compliance factors.

A high score does not guarantee legal compliance with the California Consumer Privacy Act (CCPA/CPRA) or any other regulation. A low score does not mean you are currently in violation.

For a definitive compliance determination, consult a qualified privacy attorney.`;


